import EmailIcon from "@mui/icons-material/Email";
import ForestIcon from "@mui/icons-material/Forest";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import {
  Box,
  Container,
  Divider,
  Paper,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";

function Contato() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "80vh",
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.04)} 0%, ${alpha(theme.palette.primary.light, 0.08)} 100%)`,
        py: { xs: 5, md: 8 },
      }}
    >
      <Container maxWidth="md" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
        {/* Cabeçalho */}
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: { xs: 56, sm: 72 },
              height: { xs: 56, sm: 72 },
              borderRadius: "50%",
              bgcolor: alpha(theme.palette.primary.main, 0.1),
              mb: 2.5,
            }}
          >
            <SupportAgentIcon
              sx={{ fontSize: { xs: 28, sm: 36 }, color: "primary.main" }}
            />
          </Box>
          <Typography
            variant="h3"
            component="h1"
            fontWeight={700}
            gutterBottom
            sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" } }}
          >
            Fale Conosco
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480, mx: "auto" }}>
            Dúvidas, sugestões ou problemas? Nossa equipe está pronta para ajudar.
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2.5, sm: 3, md: 4 },
              borderRadius: 3,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.12)}`,
              bgcolor: "background.paper",
              width: "100%",
              maxWidth: { xs: "100%", sm: 420 },
            }}
          >
            <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
              Informações de Contato
            </Typography>
            <Divider sx={{ mb: 2.5 }} />

            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5, mb: 2.5 }}>
              <Box
                sx={{
                  mt: 0.3,
                  flexShrink: 0,
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EmailIcon sx={{ fontSize: 18, color: "primary.main" }} />
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  E-mail
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={600}
                  component="a"
                  href="mailto:licencear@gmail.com"
                  sx={{
                    color: "primary.main",
                    textDecoration: "none",
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  licencear@gmail.com
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
              <Box
                sx={{
                  mt: 0.3,
                  flexShrink: 0,
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  bgcolor: alpha(theme.palette.success.main, 0.1),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ForestIcon sx={{ fontSize: 18, color: "success.main" }} />
              </Box>
              <Box>
                <Typography variant="caption" color="text.secondary" display="block">
                  Sistema
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  Licenciamento Ambiental Municipal
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default Contato;
